import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} elmstreetLabs. All rights reserved.</p>
    </footer>
  );
};

export default Footer;